<a
    class="font-weight-bold px-6 btn primary-ebtn"
    data-toggle="dropdown"
    aria-haspopup="true"
    aria-expanded="false"
    ngbDropdownToggle
    *ngIf="(TaggedItemData && calculationResult?.calculationSucceeded) || activityPackDetails"
>
    {{ 'PLANT_MANAGER.PrintReports' | transloco }}
</a>
<div
    [class.dropdown-menu-custom1]="Type === '0'"
    [class.dropdown-menu-custom]="Type === '1'"
    class="dropdown-menu p-0 dropdown-menu-wrap m-0 dropdown-menu-md dropdown-menu-left"
    placement="top-left"
    ngbDropdown
    *ngIf="TaggedItemData"
>
    <ul class="navi navi-hover py-5">
        <li class="navi-item">
            <a class="navi-link cursor-pointer" (click)="openCreateDataSheetModal()">
                <span class="navi-text"
                    >{{ 'INFORMATE_HEADER.BUTTONS_TEXT.EXPORT_REPORTS_OPTIONS.CREATEDATASHEET' | transloco }} -{{ TaggedItemData.namePrimary }}</span
                >
            </a>
        </li>
    </ul>
</div>

<div
    [class.dropdown-menu-custom1]="Type === '0'"
    [class.dropdown-menu-custom]="Type === '1'"
    class="dropdown-menu p-0 dropdown-menu-wrap m-0 dropdown-menu-md dropdown-menu-left"
    placement="top-left"
    ngbDropdown
    *ngIf="activityPackDetails"
>
    <ul class="navi navi-hover py-5">
        <li class="navi-item">
            <a class="navi-link cursor-pointer" (click)="openCreatePackSheet()">
                <span class="navi-text">Create Pack Sheet -{{ activityPackDetails.namePrimary }}</span>
            </a>
        </li>
    </ul>
</div>
